import React from "react";

function Winner({ winnerItem }) {
    const { title, organization, description, link, linkText, icon } = winnerItem;

    const handleIcon = () => {
        return "icon " + icon;
    };

    return (
        <div className="award-item">
            <div className="award-icon-box">
                <span className={handleIcon()}></span>
            </div>
            <div className="award-details">
                <h4 className="award-title">{title}</h4>
                <p className="award-organization">{organization}</p>
                <p className="award-description">{description}</p>
                {link && (
                    <a href={link} target="_blank" rel="noopener noreferrer" className="award-link">
                        {linkText} →
                    </a>
                )}
            </div>
        </div>
    );
}

export default Winner;
